import BoxIcon from '../../icons/BoxIcon'

const BG_COLOR = '#6b24e1'
const LINE_COLOR = '#411eb7'

export default function RescuableBox({ key }) {
  return new BoxIcon({ backgroundColor: BG_COLOR, lineColor: LINE_COLOR })
}
